import styled from 'styled-components';

import {THEME} from '../common/css/color.styles';
import {
  GOLD_300,
  GOLD_600,
  GREEN_300,
  GREEN_600,
  hexToRGB,
  MOON_950,
  RED_300,
  RED_600,
  TEAL_300,
  TEAL_600,
} from '../common/css/globals.styles';
import {Icon as IconComp} from './Icon';

type AlertProps = {
  severity: string;
};

const BG_COLORS: Record<string, string> = {
  default: `light-dark(${hexToRGB(MOON_950, 0.04)}, color-mix(in srgb, var(--white) 8%, transparent))`,
  error: `light-dark(${hexToRGB(RED_300, 0.24)}, color-mix(in srgb, var(--red-500) 24%, transparent))`,
  warning: `light-dark(${hexToRGB(GOLD_300, 0.48)}, color-mix(in srgb, var(--gold-500) 48%, transparent))`,
  info: `light-dark(${hexToRGB(TEAL_300, 0.48)}, color-mix(in srgb, var(--teal-500) 48%, transparent))`,
  success: `light-dark(${hexToRGB(GREEN_300, 0.48)}, color-mix(in srgb, var(--green-500) 48%, transparent))`,
};

const TEXT_COLORS: Record<string, string> = {
  default: THEME.textPrimary,
  error: `light-dark(${RED_600}, var(--red-400))`,
  warning: `light-dark(${GOLD_600}, var(--gold-400))`,
  info: `light-dark(${TEAL_600}, var(--teal-400))`,
  success: `light-dark(${GREEN_600}, var(--green-400))`,
};

export const Alert = styled.div<AlertProps>`
  background-color: ${props => BG_COLORS[props.severity]};
  color: ${props => TEXT_COLORS[props.severity]};
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
`;
Alert.displayName = 'S.Alert';

export const Icon = styled(IconComp)`
  font-size: 20px;
  margin-right: 8px;
  flex: 0 0 auto;
`;
Icon.displayName = 'S.Icon';

export const Message = styled.div`
  // This value chosen to make the alert the same height as our source select widgets.
  padding: 3px;
  flex: 1 1 auto;
  // Let the flex item shrink so long unbreakable strings (e.g. API keys in
  // exception messages) wrap instead of overflowing the alert horizontally.
  min-width: 0;
  overflow-wrap: break-word;
`;
Message.displayName = 'S.Message';
